import { isEmpty } from "lodash";
import { AnimatePresence, motion } from "framer-motion";
import { useTabIndicator } from "../../../components/useTabIndicator";
import useSportsBookLogic from "../../useLogic/useSportbookLogic";
const SportBook = ({
  data,
  user,
  detail,
  profileData,
  setBetSlipObject,
  favouriteList,
  position,
  BetSlip,
  addToFavioute,
}) => {
  const { header,
    setHeader,
    selected,
    setSelected,
    active,
    setActive,
    handelChange,
    sportBookCheck,
    updatedData,
    parlyBet,
    parlay,
    betSlipObject,
    showBetDialog,
  } = useSportsBookLogic({
    data,
    user,
    detail,
    profileData,
    setBetSlipObject,
    favouriteList,
    position,
    BetSlip,
    addToFavioute,
  });

  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);
  return updatedData?.length > 0 ? (
    <div>
      <div
        data-v-b21f4b8c
        className="flex items-center"
        style={{
          "--8f2b3936": `${indicatorStyle?.width || 44}px`,
          "--d946a2ea": `translateX(${indicatorStyle?.x || 10}px)`,
        }}
      >
        <div
          data-v-b21f4b8c
          className="w-full overflow-x-scroll h-30px relative flex items-center bg-market-tab-active pt-px text-market-tab-text"

        >
          <div data-v-b21f4b8c className="relative inline-block mr-2">
            <div
              ref={containerRef}
              data-v-b21f4b8c
              className="w-full flex jusrify-center px-2 h-30px cursor-pointer"
            >
              {premiumCategoryArray?.map((res, index) => {
                return (
                  <div
                    onClick={() => {
                      setHeader(res?.type);
                      setActiveIndex(index);
                    }}
                    data-v-b21f4b8c
                    name="All"
                    className="text-center py-2 px-4 mx-1 font-bold text-13"
                  >
                    {res?.name}
                  </div>
                );
              })}
            </div>
            <div
              data-v-b21f4b8c
              className="tab-indicator absolute left-0 bottom-1 bg-market-tab-text rounded-full"
            />
          </div>
        </div>
        <div
          data-v-b21f4b8c
          className="flex items-center bg-market-tab-active h-30px"
        >
          <div
            data-v-b21f4b8c
            className="icon-info-circle w-4 h-4 text-market-sub-icon mx-2"
          />
        </div>
      </div>
      <div className="p-2 bg-white rounded-b-lg">
        {updatedData?.map((item, index) => {
          if (item?.sportsBookSelection?.length > 0) {
            let lockOuter =
              item?.apiSiteStatus == "SUSPENDED" || item?.marketStatus != 1;
            let animate = favouriteList?.includes(item.id);
            return (
              <AnimatePresence>
                <motion.div
                  key={item.id}
                  layout={animate} // Animate only clicked item
                  initial={animate ? { opacity: 0, y: 10 } : false}
                  animate={animate ? { opacity: 1, y: 0 } : {}}
                  exit={{ opacity: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 500,
                    damping: 30,
                    mass: 0.5,
                  }}
                  className="mb-1"
                >
                  <div>
                    <div
                      onClick={() =>
                        setActive((prev) => {
                          if (prev.includes(index)) {
                            return prev?.filter((obj) => {
                              return obj != index;
                            });
                          } else {
                            return [...prev, index];
                          }
                        })
                      }
                      className="relative py-2 pl-0 mb-0.5 flex justify-start items-center rounded-t-lg bg-black-100"
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          addToFavioute(detail?.eventId, "SportBook", item?.id);
                        }}
                        data-v-117db823
                        className="w-8 h-6 flex justify-center items-center"
                        style={{
                          "--b64d5fc0": "0.4363636363636363",
                          "--3cad14f0": "-0.9375rem",
                        }}
                      >
                        <div
                          data-v-117db823
                          className={`fave bg-star-sprit-black-webp ${animate ? "animate" : ""
                            }`}
                        />
                      </div>
                      <span className="text-13 font-bold px-2 flex-1">
                        {item?.marketName}
                      </span>
                      <i
                        className={`icon-arrow-down-sencodary text-12 mr-3 justify-self-end text-black transition-transform origin-center duration-300 transform ${active?.includes(index) ? "rotate-180" : ""
                          } `}
                      />
                    </div>
                    {active?.includes(index) && (
                      <div className="grid grid-cols-2 gap-0.5 relative">
                        {item?.sportsBookSelection?.map((res, id) => {
                          if (Number(res?.odds) > 0) {
                            let newPosition = "";
                            if (
                              showBetDialog &&
                              betSlipObject?.playType == "sportBook" &&
                              item?.id == selected
                            ) {
                              let backProfit =
                                (Number(betSlipObject?.odds) - 1) *
                                Number(betSlipObject?.bidPrice);
                              let backLoss = Number(betSlipObject?.bidPrice);
                              if (res?.id == betSlipObject?.object?.id) {
                                newPosition =
                                  Math.abs(res?.position) > 0
                                    ? Number(backProfit) + Number(res.position)
                                    : Number(backProfit);
                              } else {
                                newPosition =
                                  Math.abs(res?.position) > 0
                                    ? Number(res?.position) - Number(backLoss)
                                    : -Number(backLoss);
                              }
                            }
                            let activeClass = parlay
                              ? sportBookCheck(parlyBet, detail, res)
                              : betSlipObject?.teamName == res?.selectionName &&
                              betSlipObject?.odds == res?.odds &&
                              item?.marketName ==
                              betSlipObject?.item?.marketName &&
                              showBetDialog;
                            let conditionShowPositon = !isEmpty(
                              position?.find((res) => {
                                return (
                                  res?.marketId ==
                                  `${item?.betfairEventId}S${item?.id}`
                                );
                              })
                            );
                            let conditionPosition =
                              showBetDialog &&
                                betSlipObject?.playType == "sportBook" &&
                                item?.id == selected &&
                                Number(betSlipObject?.bidPrice) > 0
                                ? true
                                : false;
                            let lock =
                              res?.isActive != 1 ||
                              item?.apiSiteStatus == "SUSPENDED" ||
                              item?.marketStatus != 1;

                            let oldObject = item?.oldSportsBookSelection?.find(
                              (obj) => {
                                return obj?.id == res?.id;
                              }
                            );

                            return (
                              <div
                                onClick={(e) => {
                                  if (!lock) {
                                    handelChange(res?.odds, item, res, e);
                                    setSelected(item?.id);
                                  }
                                }}
                                data-v-9b33b0db
                                className={`py-1.5 text-center flex flex-col justify-center items-center bg-back-200 rounded-b-md ${activeClass ? "back-active" : ""
                                  } ${res?.odds != oldObject?.odds
                                    ? "animate-spark-back"
                                    : ""
                                  }`}
                                title="back"
                              >
                                <p data-v-9b33b0db className="text-9 pb-1 px-1">
                                  {res?.selectionName}
                                </p>
                                <p
                                  data-v-9b33b0db
                                  className="text-15 font-bold min-h-15px"
                                >
                                  {res?.odds}
                                </p>
                                <div
                                  data-v-9b33b0db
                                  className="rounded-full px-2 mt-0.5 bg-white bg-opacity-40"
                                >
                                  {Math.abs(res?.position) > 0 && (
                                    <span
                                      className={`text-10 leading-normal flex font-bold ${res?.position > 0
                                          ? "text-success"
                                          : "text-error"
                                        }`}
                                      ata-v-9b33b0db
                                      data-testid="forecast"
                                    >
                                      {res?.position > 0
                                        ? Math.abs(res?.position).toFixed(2)
                                        : `( ${Math.abs(res?.position).toFixed(
                                          2
                                        )} )`}
                                    </span>
                                  )}
                                  {!parlay &&
                                    !isNaN(Math.abs(newPosition) > 0) &&
                                    conditionPosition && (
                                      <span
                                        className={`text-10 leading-normal flex font-bold ${newPosition > 0
                                            ? "text-success"
                                            : "text-error"
                                          } `}
                                        ata-v-9b33b0db
                                        data-testid="forecast"
                                      >
                                        {" "}
                                        <span className="s-icon-arrow-left s-rotate-180 s-flex s-text-6px s-mx-0.5" />{" "}
                                        {newPosition > 0
                                          ? Math.abs(newPosition).toFixed(2)
                                          : `( ${Math.abs(newPosition).toFixed(
                                            2
                                          )} )`}
                                      </span>
                                    )}
                                </div>
                              </div>
                            );
                          }
                        })}

                        <div className="absolute w-full h-full bg-black-600 bg-opacity-60 rounded-b-lg overflow-hidden">
                          <span className="w-full h-full flex justify-center items-center text-global-font-on-dark text-11 bg-black-700 opacity-80">
                            Suspend
                          </span>
                        </div>

                      </div>
                    )}
                  </div>
                </motion.div>
              </AnimatePresence>
            );
          }
        })}
        <div className="flex items-center justify-end text-black-500 pb-1">
          <i className="icon-min-max px-1 text-base" />
          <span className="mr-0.5 px-0.5 text-11">min</span>
          <mark className="font-bold bg-white text-11 text-black-500">1</mark>
        </div>
      </div>
    </div>
  ) : (
    <div className="bg-white rounded-b-xl">
      <div className="bg-market-tab-active h-3px" />
      <div className="py-3 px-4">Markets Mapping…</div>
    </div>
  );
};

export default SportBook;
const premiumCategoryArray = [
  { type: "all", name: "All" },
  { type: "Popular", name: "Popular" },
  { type: "Match", name: "Match" },
  { type: "Innings", name: "Innings" },
  { type: "Over", name: "Over" },
  { type: "Batsman", name: "Batsman" },
];
